module.exports = __webpack_public_path__ + "static/img/4.593ec2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/13/03/4.png
// module id = pV2x
// module chunks = 2